import "./style.scss";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FC, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setSearchQuery } from "@/src/store/slices/ApplicationPage/applicationsFiltersSlice";
import HeaderApplications from "./SubHeader/HeaderApplications";
import HeaderTasks from "./SubHeader/HeaderTasks";
import HeaderHome from "./SubHeader/HeaderHome";
import HeaderAdmissionsOffice from "./SubHeader/HeaderAdmissionsOffice";
import HeaderUser from "./SubHeader/HeaderUser";
import SearchSvg from "@/src/svg/default/SearchSvg";
import NotificationSvg from "@/src/svg/header/NotificationSvg";
import ContactSvg from "@/src/svg/header/ContactSvg";
import StatusSvg from "@/src/svg/header/StatusSvg";
import ArrowBottom from "@/src/svg/header/ArrowBottom";
import UserSvg from "@/src/svg/header/UserSvg";
import { userAuthRequests } from "@/src/api/userInfoRequests";
import HeaderAdmissionsOfficeDatabase from "./SubHeader/HeaderAdmissionsOfficeDatabse";
import { setFilterAndSearch } from "@/src/store/slices/AdmissionOfficeDatabase/AODatabaseTableSlice";
import { setSearchQuery as setTasksSearchQuery } from "@/src/store/slices/TasksPage/tasksFiltersSlice";
import { setSearchQuery as setOfficeAccountingSearchQuery } from "@/src/store/slices/OfficeAccountingPage/officeAccountingFiltersSlice";
import VerticalLine from "../VerticalLine/VerticalLine";
import HeaderOfficeAccounting from "./SubHeader/HeaderOfficeAccounting";

interface IHeaderProps {
  username: string | null;
}

const Header: FC<IHeaderProps> = ({ username }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const location = useLocation();
  const [currentPageTitle, setCurrentPageTitle] = useState("Home");
  const [searchInputValue, setSearchInputValue] = useState("");

  useEffect(() => {
    const path = location.pathname;
    if (path.startsWith("/applications")) {
      setCurrentPageTitle("Online applications");
    } else if (path.startsWith("/tasks")) {
      setCurrentPageTitle("My Tasks");
    } else if (path.startsWith("/admissions-office-database")) {
      setCurrentPageTitle("Admissions Office Database");
    } else if (path.startsWith("/admissions-office")) {
      setCurrentPageTitle("Admissions Office");
    } else if (path.startsWith("/user")) {
      setCurrentPageTitle("User");
    } else if (path.startsWith("/office-accounting")) {
      setCurrentPageTitle("Office Accounting");
    } else if (path.startsWith("/documents-qr-code")) {
      setCurrentPageTitle("Documents QR Code");
    } else {
      setCurrentPageTitle("Home");
    }
  }, [location.pathname]);

  const handleSearch = () => {
    const path = location.pathname;

    if (path.startsWith("/applications")) {
      dispatch(setSearchQuery(searchInputValue));
    } else if (path.startsWith("/tasks")) {
      dispatch(setTasksSearchQuery(searchInputValue));
    } else if (path.startsWith("/office-accounting")) {
      dispatch(setOfficeAccountingSearchQuery(searchInputValue));
    } else if (path.startsWith("/admissions-office-database")) {
      dispatch(setFilterAndSearch({ key: "query", value: searchInputValue }));
    } else if (path.startsWith("/admissions-office")) {
      console.log("Admissions office search:", searchInputValue);
      // если позже надо будет добавить search — место готово
    } else {
      console.log("Home search:", searchInputValue);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const handleLogoutClick = async () => {
    try {
      const userAuthInfo = await userAuthRequests.singOut();
      localStorage.clear();
      navigate("/login", { replace: true });
      console.log("Пользователь вышел, localStorage очищен", userAuthInfo);
    } catch (error) {
      console.error("Ошибка при разлогине:", error);
    }

    console.log("Log out clicked");
  };

  return (
    <div className="header">
      <div className="header-top">
        <div className="header-top-text">
          <div className="header-top-title">
            <p>{currentPageTitle}</p>
          </div>
          <div className="header-top-subtitle">
            <p>Last updated 5 min ago</p>
          </div>
        </div>
        <div className="header-top-content">
          <div className="header-top-search">
            <div onClick={handleSearch} style={{ cursor: "pointer" }}>
              <SearchSvg />
            </div>
            <input
              type="text"
              placeholder="Search"
              value={searchInputValue}
              onChange={(e) => setSearchInputValue(e.target.value)}
              onKeyDown={handleKeyDown}
            />
          </div>
          <VerticalLine />
          <div className="header-top-info">
            <Link to={"#"}>
              <NotificationSvg />
            </Link>
            <Link to={"#"}>
              <ContactSvg />
            </Link>
            <Link to={"#"}>
              <StatusSvg />
            </Link>
          </div>
          <VerticalLine />
          <div className="header-top-user">
            <div className="header-top-user-svg">
              <UserSvg />
            </div>
            <div className="header-top-user-arrow">
              <ArrowBottom />
            </div>

            <div className="header-top-user-menu">
              <p className="header-top-user-menu-title">Hi, {username} !</p>
              <Link to="/profile">
                <button>Profile</button>
              </Link>
              <button onClick={() => handleLogoutClick()}>Log Out</button>
            </div>
          </div>
        </div>
      </div>
      <div className="header-bottom">
        {currentPageTitle === "Online applications" && <HeaderApplications />}
        {currentPageTitle === "My Tasks" && <HeaderTasks />}
        {currentPageTitle === "Admissions Office" && <HeaderAdmissionsOffice />}
        {currentPageTitle === "Documents QR Code" && <HeaderAdmissionsOffice />}
        {currentPageTitle === "Admissions Office Database" && <HeaderAdmissionsOfficeDatabase />}
        {currentPageTitle === "User" && <HeaderUser />}
        {currentPageTitle === "Home" && <HeaderHome />}
        {currentPageTitle === "Office Accounting" && <HeaderOfficeAccounting />}
      </div>
    </div>
  );
};

export default Header;
